export default "__VITE_ASSET__BnBQ2M0g__"